import React from 'react';

const ES = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_157"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_157)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#CD0B20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4H21V11H0V4Z"
        fill="#FFCB00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6.22201V8.742C9 9.442 8.328 10.002 7.5 10.002H5.5C4.674 10 4 9.43701 4 8.74001V6.22C4 5.648 4.448 5.17001 5.064 5.01501C5.25 4.49501 5.822 4.96101 6.5 4.96101C7.182 4.96101 7.75 4.498 7.936 5.016C8.55 5.175 9 5.65401 9 6.22201Z"
        fill="#C8B47C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 7H10V10H9V7ZM3 7H4V10H3V7Z"
        fill="#B5B5B5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9H10V10H9V9ZM3 9H4V10H3V9Z"
        fill="#165C96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6H10V7H9V6ZM3 6H4V7H3V6Z"
        fill="#A0790A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6H6V7.5H5V6ZM7 8H8V9.5H7V8Z"
        fill="#D20636"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 6H8V7.5H7V6Z"
        fill="#A18793"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8H6V9.5H5V8Z"
        fill="#FFE100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6L5 5H8L7 6H6Z"
        fill="#B6161A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4H7V5H6V4Z"
        fill="#AC9300"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default ES;
